<template>
  <v-dialog
    v-model="show"
    persistent
    scrollable
    :max-width="$spec.dialog_standard_max_width"
  >
    <v-card>
      <v-card-title class="headline">新增用戶</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            label="姓名"
            v-model="name"
            :rules="nameRules"
          ></v-text-field>
          <v-text-field
            :loading="phoneLoading"
            label="電話"
            v-model="phone"
            :rules="phoneRules"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="show = false">取消</v-btn>
        <v-btn color="green" text @click="create" :loading="loading"
          >建立</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: thisVm => ({
    show: false,
    name: "",
    nameRules: [v => !!v || "請輸入姓名"],
    phone: "",
    duplicatePhone: false,
    phoneLoading: false,
    phoneRules: [
      v => !!v || "請輸入電話號碼",
      () => !thisVm.duplicatePhone || "電話號碼已被使用"
    ],
    loading: false
  }),
  watch: {
    async phone(val) {
      if (String(val).length > 9) {
        console.log(val);
        this.phoneLoading = true;
        let response = await this.$ajax.post(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/search/user`,
          { phone: val }
        );
        this.phoneLoading = false;
        this.duplicatePhone = response.data.length > 0;
        this.$refs.form.validate();
      }
    }
  },
  methods: {
    async showDialog() {
      if (this.$refs.form) {
        this.$refs.form.reset();
        await this.$nextTick();
      }
      this.show = true;
    },
    async create() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        await this.$ajax.post(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/users`,
          { phone: this.phone, name: this.name, permission: "role_user" }
        );

        this.show = false;
        this.loading = false;
        this.$emit("created");
      }
    }
  }
};
</script>
